const tagFamilyConstants = Object.freeze({
  COST_CENTER: 'cost_center',
  EXPENSE: 'expense',
  VENDORS: 'vendors',
  TEAM: 'team',
  PROJECT: 'project',
  LOCATION: 'location',
  GENERIC_EXPENSE: 'generic_expense',
  INVOICE: 'invoice',
});

/**
 * Maps expense form field names to their corresponding tag family constants.
 * Used to drive dynamic tag selects for mandatory fields.
 */
const TAG_FIELD_TO_FAMILY = Object.freeze({
  tags: tagFamilyConstants.COST_CENTER,
  team_tags: tagFamilyConstants.TEAM,
  location_tags: tagFamilyConstants.LOCATION,
  project_tags: tagFamilyConstants.PROJECT,
  generic_expense_tags: tagFamilyConstants.GENERIC_EXPENSE,
  invoice_tags: tagFamilyConstants.INVOICE,
});

export {
  tagFamilyConstants,
  TAG_FIELD_TO_FAMILY,
};
